import React from "react";
import Sort from "../../Components/pages/sort/sort";

function Index() {
  return <Sort />;
}

export default Index;
